import { render } from "./tcShopVipManage.vue?vue&type=template&id=2876703c"
import script from "./tcShopVipManage.vue?vue&type=script&lang=js"
export * from "./tcShopVipManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__